import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { AdminAuthMatrix } from '../models/admin-auth-matrix.model';
import { CompanyContact } from '../models/company-contract.model';
import { OAuthUserInfo } from '../models/oauthuserinfo.model';
import { ApiService } from './api.service';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class MyProfileService {

  private userInfosSubscription: Subscription;
  private userSub: string;

  constructor(private apiService: ApiService, private sessionStorage: SessionStorageService) {
    this.userInfosSubscription = this.sessionStorage.userInfosChange.subscribe( (data: string) => {
      const userInfo: OAuthUserInfo = JSON.parse(data) as OAuthUserInfo;
      if (userInfo) {
        this.userSub = userInfo.sub;
      }
    });
  }

  public getCompanyContactsByUser(): Promise<Array<CompanyContact>> {
    if (!this.userSub) { return; }

    return this.apiService.get(`/company/contacts/${this.userSub}`);
  }

  public getCompanyContactsByCompany(companyId: string): Promise<Array<CompanyContact>> {
    return this.apiService.get(`/company/${companyId}/contacts`);
  }

  public getAdminAuthMatrix(): Promise<AdminAuthMatrix> {
    if (!this.userSub) { return; }

    return this.apiService.get(`/users/${this.userSub}`);
  }

  public createCompanyContact(data: any) {
    return this.apiService.post('/company/contacts', data);
  }

  public updateCompanyContact(data: any) {
    return this.apiService.put('/company/contacts/1', data);
  }

  public deleteCompanyContact(data: any) {
    const endpointUrl = '/company/contacts/' + data.createdUserId + '/' + data.companyId + '/' + data.seq;
    return this.apiService.delete(endpointUrl);
  }

  public getUserAttributes(): Promise<any> {
    if (!this.userSub) { return; }

    return this.apiService.get(`/user/${this.userSub}`);
  }

  public putUserAttributes(): Promise<any> {
    if (!this.userSub) { return; }

    return this.apiService.put(`/user/${this.userSub}`);
  }

  public getUser(): Promise<any> {
    if (!this.userSub) { return; }

    return this.apiService.get(`/users/${this.userSub}`);
  }

  public getSelf(): Promise<any> {
    if (!this.userSub) { return; }

    return this.apiService.get(`/users/self`);
  }

  public updateSelf(user: any): Promise<any> {
    if (!this.userSub) { return; }

    user.userId = this.userSub;

    return this.apiService.put(`/users/self`, user);
  }

  public updateUser(user: any): Promise<any> {
    if (!this.userSub) { return; }

    user.userId = this.userSub;

    return this.apiService.put(`/users/${this.userSub}`, user);
  }
}
